<div *ngIf="!(hideIfNoData && zillowError)">

    <span class="zillow-percent" *ngIf="showPricePercentage">
        Purchase Price is {{percentBelowZestimate}} below Zestimate®
    </span>

    <p class="title">
        Valuation
        <a href="http://www.zillow.com/" target="_blank"><img src="./assets/img/Zillowlogo_200x50.gif"
                                                              alt="Real Estate on Zillow"></a>
    </p>

    <ion-grid class="box">

        <ion-row *ngIf="zillowError">
            <ion-col>
                <div>
                    <ion-text color="danger">Unable to find Zestimate Values</ion-text>
                </div>
            </ion-col>
        </ion-row>

        <ion-row *ngIf="!zillowError && !zillowInfo">
            <ion-col>
                <div>
                    <ion-text>Loading Zestimate...</ion-text>
                </div>
            </ion-col>
        </ion-row>

        <ion-row *ngIf="!zillowError && zillowInfo">

            <ion-col class="rent-zestimate-col" size="12" size-lg="">
                <div>
                    <p class="sub-title">Rent Zestimate®</p>

                    <ion-grid>
                        <ion-row>
                            <ion-col size="12" size-sm="">
                                <div>
                                    <p class="label">Rent Zestimate ®</p>
                                    <p class="value">
                                        {{ zillowInfo.rentZestimate.amount | currency:'USD':'symbol':'1.0-0' }} / month
                                    </p>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-sm="">
                                <div>
                                    <p class="label">Range of Value</p>
                                    <p class="value">
                                        {{ zillowInfo.rentZestimate.range.low | currency:'USD':'symbol':'1.0-0' }} -
                                        {{ zillowInfo.rentZestimate.range.high | currency:'USD':'symbol':'1.0-0' }}</p>
                                </div>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col size="12" size-sm="">
                                <div>
                                    <p class="label">30 Day Forecast</p>
                                    <p class="value">
                                        {{ zillowInfo.rentZestimate.thirtyDayChange | currency:'USD':'symbol':'1.0-0' }}
                                    </p>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-sm="">
                                <div>
                                    <p class="label">Last Updated</p>
                                    <p class="value">{{ zillowInfo.rentZestimate.lastUpdated }}</p>
                                </div>
                            </ion-col>
                        </ion-row>
                    </ion-grid>

                </div>
            </ion-col>

            <ion-col class="zestimate-col" size="12" size-lg="">
                <div>
                    <p class="sub-title">Zestimate®</p>

                    <ion-grid class='estimate-grid'>
                        <ion-row>
                            <ion-col size="12" size-sm="">
                                <div>
                                    <p class="label">Zestimate ®</p>
                                    <p class="value">
                                        {{ zillowInfo.sellZestimate.amount | currency:'USD':'symbol':'1.0-0' }}</p>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-sm="">
                                <div>
                                    <p class="label">Range of Value</p>
                                    <p class="value">
                                        {{ zillowInfo.sellZestimate.range.low | currency:'USD':'symbol':'1.0-0' }} -
                                        {{ zillowInfo.sellZestimate.range.high | currency:'USD':'symbol':'1.0-0' }}</p>
                                </div>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col size="12" size-sm="">
                                <div>
                                    <p class="label">30 Day Forecast</p>
                                    <p class="value">
                                        {{ zillowInfo.sellZestimate.thirtyDayChange | currency:'USD':'symbol':'1.0-0' }}
                                    </p>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-sm="">
                                <div>
                                    <p class="label">Last Updated</p>
                                    <p class="value">{{ zillowInfo.sellZestimate.lastUpdated }}</p>
                                </div>
                            </ion-col>
                        </ion-row>
                    </ion-grid>

                </div>
            </ion-col>
        </ion-row>
    </ion-grid>
</div>
